module.exports = __webpack_public_path__ + "static/media/7.31e3edc0.jpg";